import { addToast } from '@app/components/various/Toasts';
import { LOOKBOOK_BY_ID_QUERY_KEY } from '@app/services/hooks/lookbook/useLookbookDetails';
import { updateLookbookByIdSettingsGeneral } from '@app/services/lookbookRepository';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Id, Lookbook } from '@typings/@centra';
import { useTranslation } from 'react-i18next';

interface MutationVariables {
  lookbookId: Id;
  data: Lookbook.UpdateLookbookGeneralSettingsDTO;
}

export const useUpdateLookbookSettingsGeneral = () => {
  const { t } = useTranslation(['lookbook']);
  const queryClient = useQueryClient();

  const mutationFn = async ({ lookbookId, data }: MutationVariables) => {
    return updateLookbookByIdSettingsGeneral(lookbookId, data);
  };

  const handleSuccess = (_data: Lookbook.GeneralSettingsResponse, variables: MutationVariables) => {
    addToast(t('lookbook:general_settings_updated'));

    queryClient.invalidateQueries({ queryKey: [LOOKBOOK_BY_ID_QUERY_KEY, { lookbookId: variables.lookbookId }] });
  };

  const handleError = () => {
    addToast(t('lookbook:unable_to_update_general settings'));
  };

  return useMutation({
    mutationFn,
    onError: handleError,
    onSuccess: handleSuccess,
  });
};
